var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdering({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.4,
    y: 246.66,
    width: 18.81,
    height: 18.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.22,
    y: 246.66,
    width: 11.56,
    height: 18.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.84 246.66 416.84 253.78 417.14 253.5 417.67 253.84 418.13 253.5 418.72 253.84 419.35 253.5 419.75 253.84 420.21 253.59 420.21 246.66 416.84 246.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.84 246.66 416.84 253.78 417.14 253.5 417.67 253.84 418.13 253.5 418.72 253.84 419.35 253.5 419.75 253.84 420.21 253.59 420.21 246.66 416.84 246.66",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.45,
    y: 268.94,
    width: 24.61,
    height: 24.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.06,
    y: 268.94,
    width: 15.12,
    height: 24.61,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.36 275.86 383.75 275.86 388.45 268.94 413.06 268.94 408.36 275.86",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.52 275.86 432.63 275.86 428.18 268.94 413.06 268.94 417.52 275.86",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.52,
    cy: 257.86,
    r: 13.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.4,
    cy: 257.86,
    r: 13.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.4,
    cy: 257.86,
    r: 10.49,
    transform: "translate(-153.22 145.81) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.51,257.86a10.47,10.47,0,0,1,9.69-10.44c-.27,0-.53,0-.8,0a10.49,10.49,0,0,0,0,21c.27,0,.53,0,.8,0A10.48,10.48,0,0,1,90.51,257.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,261.66a4.61,4.61,0,0,1-2.7,1.13v1.74H99v-1.7a8.39,8.39,0,0,1-2.2-.4,5.72,5.72,0,0,1-1.68-.84l.86-1.91a5.71,5.71,0,0,0,1.39.74,6.53,6.53,0,0,0,1.63.37v-2.6a11.81,11.81,0,0,1-1.87-.6,3.26,3.26,0,0,1-1.28-.95,2.59,2.59,0,0,1-.51-1.68,3,3,0,0,1,.94-2.22A4.46,4.46,0,0,1,99,251.61v-1.73h1.56v1.7a6.85,6.85,0,0,1,3.17.95l-.78,1.92a6.12,6.12,0,0,0-2.39-.81v2.65a10.83,10.83,0,0,1,1.85.56,3.43,3.43,0,0,1,1.27.95,2.6,2.6,0,0,1,.51,1.67A3,3,0,0,1,103.27,261.66Zm-5.11-6.19a2.4,2.4,0,0,0,.85.43v-2.22a1.71,1.71,0,0,0-.87.45,1,1,0,0,0-.28.71A.77.77,0,0,0,98.16,255.47Zm3.25,4.85a.89.89,0,0,0,.28-.67.81.81,0,0,0-.28-.64,2.62,2.62,0,0,0-.84-.43v2.15A1.58,1.58,0,0,0,101.41,260.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.71,
    cy: 134.81,
    r: 13.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.58,
    cy: 134.81,
    r: 13.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.58,
    cy: 134.81,
    r: 10.49,
    transform: "translate(-14.02 235.77) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,134.81a10.49,10.49,0,0,1,9.69-10.45c-.26,0-.53,0-.8,0a10.49,10.49,0,0,0,0,21c.27,0,.54,0,.8,0A10.47,10.47,0,0,1,268.69,134.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,138.6a4.49,4.49,0,0,1-2.7,1.13v1.75H277.2v-1.7a8.32,8.32,0,0,1-2.2-.41,5.67,5.67,0,0,1-1.69-.84l.86-1.9a5.88,5.88,0,0,0,1.39.73,6.52,6.52,0,0,0,1.64.38v-2.61a11.06,11.06,0,0,1-1.88-.59,3.35,3.35,0,0,1-1.27-1,2.53,2.53,0,0,1-.52-1.67,3,3,0,0,1,1-2.23,4.52,4.52,0,0,1,2.72-1.13v-1.73h1.55v1.7a6.93,6.93,0,0,1,3.17.95l-.78,1.92a6.12,6.12,0,0,0-2.39-.81v2.65a11.73,11.73,0,0,1,1.85.57,3.16,3.16,0,0,1,1.27.95,2.55,2.55,0,0,1,.52,1.66A3,3,0,0,1,281.45,138.6Zm-5.11-6.18a2.3,2.3,0,0,0,.86.42v-2.21a1.7,1.7,0,0,0-.88.44,1,1,0,0,0-.28.71A.8.8,0,0,0,276.34,132.42Zm3.26,4.85a1,1,0,0,0,.28-.67.82.82,0,0,0-.29-.64,2.51,2.51,0,0,0-.84-.44v2.15A1.73,1.73,0,0,0,279.6,137.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.9,
    cy: 273.04,
    r: 9.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.37,
    cy: 273.04,
    r: 9.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.37,
    cy: 273.04,
    r: 7.54,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,273a7.55,7.55,0,0,1,7-7.52c-.19,0-.38,0-.58,0a7.55,7.55,0,0,0,0,15.09,5.49,5.49,0,0,0,.58,0A7.54,7.54,0,0,1,176,273Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.16,275.77a3.37,3.37,0,0,1-1.95.81v1.26h-1.12v-1.23a5.89,5.89,0,0,1-1.58-.29,4.14,4.14,0,0,1-1.21-.6l.62-1.37a4.1,4.1,0,0,0,1,.53,4.31,4.31,0,0,0,1.17.26v-1.87a8.16,8.16,0,0,1-1.34-.43,2.24,2.24,0,0,1-.92-.68,1.86,1.86,0,0,1-.37-1.21,2.15,2.15,0,0,1,.68-1.6,3.25,3.25,0,0,1,2-.81v-1.25h1.12v1.23a4.91,4.91,0,0,1,2.28.68l-.56,1.38a4.34,4.34,0,0,0-1.72-.58v1.9a8.16,8.16,0,0,1,1.33.41,2.33,2.33,0,0,1,.92.69,1.86,1.86,0,0,1,.37,1.19A2.17,2.17,0,0,1,185.16,275.77Zm-3.68-4.45a1.65,1.65,0,0,0,.61.3V270a1.17,1.17,0,0,0-.62.32.73.73,0,0,0-.21.51A.55.55,0,0,0,181.48,271.32Zm2.34,3.49a.7.7,0,0,0,.2-.49.57.57,0,0,0-.21-.45,1.66,1.66,0,0,0-.6-.32v1.55A1.24,1.24,0,0,0,183.82,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.68,
    cy: 94.06,
    r: 9.81,
    transform: "translate(-5.1 175.81) rotate(-45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.15,
    cy: 94.06,
    r: 9.81,
    transform: "translate(-5.55 174.74) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.15,
    cy: 94.06,
    r: 7.54,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.75,94.06a7.54,7.54,0,0,1,7-7.51,5.44,5.44,0,0,0-.57,0,7.55,7.55,0,0,0,0,15.09c.19,0,.38,0,.57,0A7.56,7.56,0,0,1,201.75,94.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.93,96.79a3.22,3.22,0,0,1-1.94.81v1.26h-1.12V97.64a6.31,6.31,0,0,1-1.58-.29,4.14,4.14,0,0,1-1.21-.61l.62-1.37a3.87,3.87,0,0,0,1,.53,4.92,4.92,0,0,0,1.18.27V94.29a7.35,7.35,0,0,1-1.34-.42,2.36,2.36,0,0,1-.92-.69,1.84,1.84,0,0,1-.37-1.21,2.14,2.14,0,0,1,.67-1.59,3.25,3.25,0,0,1,2-.82V88.32H209v1.22a4.91,4.91,0,0,1,2.28.68l-.56,1.38A4.5,4.5,0,0,0,209,91v1.91a7.28,7.28,0,0,1,1.33.41,2.38,2.38,0,0,1,.92.68,1.86,1.86,0,0,1,.37,1.19A2.13,2.13,0,0,1,210.93,96.79Zm-3.68-4.45a2,2,0,0,0,.62.31v-1.6a1.33,1.33,0,0,0-.63.32.76.76,0,0,0-.2.51A.57.57,0,0,0,207.25,92.34Zm2.35,3.49a.66.66,0,0,0,.2-.48.57.57,0,0,0-.21-.46,1.68,1.68,0,0,0-.6-.31v1.54A1.2,1.2,0,0,0,209.6,95.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.38,320.27,109.7,316l15.27.81c-3.35-5.83-4.84-8.7-7.5-14.28,3.82,4.35,5.81,6.56,10,11a125.22,125.22,0,0,1,4.75-19.08,82.32,82.32,0,0,0-1.3,16.8l.28.06A135.88,135.88,0,0,1,145.9,297a109.15,109.15,0,0,0-13.32,17.53q8.53-3.22,17.19-6.13c-5.78,3.16-11.43,6.42-17.07,9.84l14.14,4.51-14.62-.89c3.08,3.61,4.68,5.43,8,9.08-4.11-2.71-6.14-4.06-10.15-6.76a94.07,94.07,0,0,0,2,11.17c-2-4.56-2.88-6.83-4.42-11.3-2.87,13.73-2.12,27,.65,40.69l-3.44-.62a106.84,106.84,0,0,1,1.61-40.28c-3.46,3.57-5.08,5.38-8.08,9a93.16,93.16,0,0,1,5.81-9.76c-4.93,1.08-7.36,1.63-12.19,2.73C116.44,323.59,118.71,322.47,123.38,320.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,325l12.64-6.7L116.32,322c2.2-6.35,3.14-9.45,4.7-15.43-2.94,5-4.48,7.53-7.75,12.71A125.49,125.49,0,0,0,105,301.37a82.52,82.52,0,0,1,4.42,16.26l-.27.1a136.84,136.84,0,0,0-17.13-11.38,110,110,0,0,1,16.35,14.74q-9-1.57-18-2.81c6.27,2,12.43,4.17,18.61,6.48l-13.06,7.07,14.2-3.6c-2.35,4.12-3.58,6.2-6.16,10.41,3.54-3.43,5.28-5.14,8.71-8.53a92.89,92.89,0,0,1,.12,11.34c1.11-4.85,1.55-7.24,2.23-11.93,5.38,13,7.14,26.17,7,40.1l3.26-1.25a107,107,0,0,0-9.1-39.28c4.07,2.87,6,4.35,9.63,7.38a94.12,94.12,0,0,0-7.53-8.5c5,.14,7.54.22,12.48.4C126,327,123.52,326.31,118.53,325Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,332.53l-9.21-4.88,10.82,2.65c-1.61-4.62-2.29-6.88-3.43-11.24,2.14,3.63,3.27,5.48,5.65,9.26a91.3,91.3,0,0,1,6-13,60.23,60.23,0,0,0-3.22,11.85l.2.08a99.15,99.15,0,0,1,12.49-8.3,80.07,80.07,0,0,0-11.93,10.75q6.56-1.15,13.15-2.05c-4.57,1.48-9.06,3-13.56,4.72l9.51,5.15L137,334.88c1.71,3,2.61,4.52,4.49,7.59-2.57-2.5-3.84-3.75-6.35-6.22a66.87,66.87,0,0,0-.08,8.27c-.81-3.54-1.14-5.28-1.63-8.7-3.92,9.45-5.2,19.08-5.07,29.23l-2.38-.91a77.64,77.64,0,0,1,6.64-28.63c-3,2.09-4.38,3.17-7,5.38a68.65,68.65,0,0,1,5.49-6.2c-3.67.11-5.49.17-9.1.3C125.47,334,127.25,333.48,130.89,332.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.1 382.38 112.89 382.38 110.71 346.99 137.28 346.99 135.1 382.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139 348.81 108.77 348.81 108.23 344.1 139.54 344.1 139 348.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.28,
    y: 306.93,
    width: 41.46,
    height: 75.35,
    transform: "translate(790.02 689.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.55,
    y: 306.93,
    width: 11.73,
    height: 75.35,
    transform: "translate(736.83 689.21) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.27,
    y: 313,
    width: 33.16,
    height: 19.87,
    transform: "translate(789.7 645.87) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.27,
    y: 335.04,
    width: 33.16,
    height: 19.87,
    transform: "translate(789.7 689.95) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.27,
    y: 357.08,
    width: 33.16,
    height: 19.87,
    transform: "translate(789.7 734.02) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.17,317.42a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,393.17,317.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.32,317.42a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,394.32,317.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.17,339.38a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,393.17,339.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.32,339.38a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,394.32,339.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.17,361.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,393.17,361.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.32,361.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,394.32,361.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.22,115.77c-2.84,1.16-12.27-.24-12.27-.24l-1,.43a20.16,20.16,0,0,1-17.4-.78h0s-7.75.31-10.26-.2c-3.83-.77-9.54-3.8-8.11-13.36s15.77-1.29,15.77-1.29-4.14-13.45,9.83-9.39a20.79,20.79,0,0,1,15.08,17.34S172.62,110.28,159.22,115.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,128.21c-2,.8-8.49-.16-8.49-.16l-.7.3a13.94,13.94,0,0,1-12-.55h0a49.93,49.93,0,0,1-7.1-.14c-2.65-.53-6.6-2.63-5.61-9.24s10.91-.89,10.91-.89-2.86-9.31,6.8-6.5a14.38,14.38,0,0,1,10.44,12S130.51,124.41,121.23,128.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,155.33c-2.84,1.16-12.27-.23-12.27-.23l-1,.43a20.16,20.16,0,0,1-17.4-.79h0s-7.75.31-10.26-.2c-3.83-.77-9.53-3.8-8.11-13.35s15.77-1.3,15.77-1.3-4.14-13.45,9.83-9.38a20.77,20.77,0,0,1,15.08,17.33S278.67,149.84,265.27,155.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.53,115.69a16.52,16.52,0,0,0-12-13.77c-5.45-1.59-7.43.19-8,2.4a26.83,26.83,0,0,0-13.78-8.94C335.58,90.1,341,107.58,341,107.58s-18.65-10.74-20.5,1.69S326,125.63,331,126.63c3.27.66,13.34.26,13.34.26a26.18,26.18,0,0,0,22.62,1l1.33-.56s12.26,1.82,15.95.31c5.84-2.4,6.54-4.28,4.89-5.72a14.16,14.16,0,0,0,5.05-.3C404.83,117.28,387.53,115.69,387.53,115.69Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.51,148a114.39,114.39,0,0,0-170.42-5.14,1.5,1.5,0,0,1-2.11.08h0a1.51,1.51,0,0,1-.07-2.14,117.39,117.39,0,0,1,174.89,5.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,148.19h-9.34a1.5,1.5,0,0,1-1.5-1.5h0a1.5,1.5,0,0,1,1.5-1.5h6.34v-6.34a1.5,1.5,0,0,1,1.5-1.5h0a1.51,1.51,0,0,1,1.5,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,318.73l-1.69-2.48a114.41,114.41,0,0,0,48.93-78.52,1.51,1.51,0,0,1,1.67-1.29h0a1.52,1.52,0,0,1,1.31,1.7A117.44,117.44,0,0,1,316,318.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37,321.21l-9.09-2.1,2.1-9.1a1.49,1.49,0,0,1,1.79-1.12h0a1.5,1.5,0,0,1,1.13,1.8l-1.43,6.17,6.18,1.42a1.5,1.5,0,0,1,1.12,1.8h0A1.51,1.51,0,0,1,321.37,321.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,300.62a116.8,116.8,0,0,1-28.89-59.35l2.95-.5a113.75,113.75,0,0,0,28.16,57.83,1.51,1.51,0,0,1-.08,2.11h0A1.51,1.51,0,0,1,163.14,300.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,246.34h0a1.51,1.51,0,0,1-.34-2.1l5.49-7.55,7.55,5.49a1.49,1.49,0,0,1,.33,2.09h0a1.49,1.49,0,0,1-2.09.33l-5.13-3.72L132,246A1.5,1.5,0,0,1,129.87,246.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Factory--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "395.76 176.44 387.76 176.44 388.76 143.44 394.76 143.44 395.76 176.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.76 176.44 387.76 176.44 388.76 143.44 394.76 143.44 395.76 176.44",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.25 159.69 395.16 156.44 388.37 156.44 388.27 159.69 395.25 159.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.47 153.19 395.06 153.19 394.96 149.94 388.56 149.94 388.47 153.19",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.45 166.19 395.35 162.94 388.17 162.94 388.07 166.19 395.45 166.19",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.65 172.69 395.55 169.44 387.97 169.44 387.88 172.69 395.65 172.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.86 146.69 394.76 143.44 388.76 143.44 388.66 146.69 394.86 146.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.1 176.44 401.1 176.44 402.1 143.44 408.1 143.44 409.1 176.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.1 176.44 401.1 176.44 402.1 143.44 408.1 143.44 409.1 176.44",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.59 159.69 408.49 156.44 401.7 156.44 401.6 159.69 408.59 159.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.8 153.19 408.39 153.19 408.29 149.94 401.9 149.94 401.8 153.19",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.78 166.19 408.69 162.94 401.5 162.94 401.41 166.19 408.78 166.19",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.98 172.69 408.88 169.44 401.31 169.44 401.21 172.69 408.98 172.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.19 146.69 408.1 143.44 402.1 143.44 402 146.69 408.19 146.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.43 231.44 418.1 231.44 418.1 179.53 356.76 149.27 295.43 179.53 295.43 231.44",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.43 231.44 418.1 231.44 418.1 179.53 356.76 149.27 295.43 179.53 295.43 231.44",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.43,
    y: 190.35,
    width: 48.67,
    height: 41.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.43,
    y: 190.35,
    width: 8.67,
    height: 41.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.43,
    y: 190.35,
    width: 8.67,
    height: 41.08,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.93,
    y: 202.69,
    width: 7.33,
    height: 9.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.93,
    y: 202.69,
    width: 7.33,
    height: 9.1,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.26,
    y: 202.69,
    width: 4.5,
    height: 9.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.26,
    y: 202.69,
    width: 4.5,
    height: 9.1,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.06 202.69 355.06 205.46 355.18 205.36 355.38 205.49 355.56 205.36 355.8 205.49 356.04 205.36 356.19 205.49 356.37 205.39 356.37 202.69 355.06 202.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.06 202.69 355.06 205.46 355.18 205.36 355.38 205.49 355.56 205.36 355.8 205.49 356.04 205.36 356.19 205.49 356.37 205.39 356.37 202.69 355.06 202.69",
    style: {
      fill: "#900045",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.05,
    y: 202.69,
    width: 7.33,
    height: 9.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.05,
    y: 202.69,
    width: 7.33,
    height: 9.1,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.39,
    y: 202.69,
    width: 4.5,
    height: 9.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.39,
    y: 202.69,
    width: 4.5,
    height: 9.1,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.19 202.69 368.19 205.46 368.3 205.36 368.51 205.49 368.69 205.36 368.92 205.49 369.17 205.36 369.32 205.49 369.5 205.39 369.5 202.69 368.19 202.69",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.19 202.69 368.19 205.46 368.3 205.36 368.51 205.49 368.69 205.36 368.92 205.49 369.17 205.36 369.32 205.49 369.5 205.39 369.5 202.69 368.19 202.69",
    style: {
      fill: "#900045",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,181.35,356.76,151.5l-60.49,29.85a2,2,0,0,1-2.68-.91h0a2,2,0,0,1,.91-2.68L356.76,147,419,177.76a2,2,0,0,1,.91,2.68h0A2,2,0,0,1,417.25,181.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.25,181.35,356.76,151.5l-60.49,29.85a2,2,0,0,1-2.68-.91h0a2,2,0,0,1,.91-2.68L356.76,147,419,177.76a2,2,0,0,1,.91,2.68h0A2,2,0,0,1,417.25,181.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 372.43,
    y: 190.35,
    width: 8.67,
    height: 41.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.43,
    y: 190.35,
    width: 8.67,
    height: 41.08,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.76,
    y: 217.94,
    width: 28.67,
    height: 13.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.76,
    y: 217.94,
    width: 28.67,
    height: 13.5,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.92,
    y: 213.6,
    width: 4.85,
    height: 17.83,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.76,219.76a4,4,0,0,1,0-8h28.67v8Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.93,215.77a2.17,2.17,0,1,1-2.17-2.17A2.17,2.17,0,0,1,345.93,215.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.76,
    y: 213.6,
    width: 20.93,
    height: 17.83,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.76,
    y: 213.6,
    width: 20.93,
    height: 17.83,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.42 221.58 314.89 221.58 316.29 217.21 310.04 223.46 313.57 223.46 312.17 227.83 318.42 221.58",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.41,
    cy: 271.45,
    r: 20.02,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.3,
    cy: 271.45,
    r: 20.02,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.3,
    cy: 271.45,
    r: 20.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.3,
    cy: 271.45,
    r: 15.39,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,271.45a15.38,15.38,0,0,1,14.22-15.33c-.38,0-.77-.06-1.16-.06a15.39,15.39,0,1,0,0,30.78c.39,0,.78,0,1.16-.06A15.37,15.37,0,0,1,130.24,271.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.53,277a6.7,6.7,0,0,1-4,1.66v2.56h-2.29v-2.49a12.16,12.16,0,0,1-3.22-.6,8,8,0,0,1-2.47-1.23l1.25-2.79a8.53,8.53,0,0,0,2,1.07,9.5,9.5,0,0,0,2.4.55v-3.82a17.13,17.13,0,0,1-2.74-.87,4.79,4.79,0,0,1-1.88-1.41,3.76,3.76,0,0,1-.75-2.46,4.43,4.43,0,0,1,1.38-3.26,6.55,6.55,0,0,1,4-1.65v-2.54h2.29v2.49a10,10,0,0,1,4.64,1.4l-1.14,2.81a9.05,9.05,0,0,0-3.5-1.19v3.89a16.3,16.3,0,0,1,2.71.83,4.78,4.78,0,0,1,1.86,1.4,3.71,3.71,0,0,1,.76,2.44A4.33,4.33,0,0,1,150.53,277ZM143,268a3.69,3.69,0,0,0,1.26.62v-3.25A2.45,2.45,0,0,0,143,266a1.5,1.5,0,0,0-.41,1A1.18,1.18,0,0,0,143,268Zm4.78,7.11a1.32,1.32,0,0,0,.42-1,1.18,1.18,0,0,0-.43-.94,3.73,3.73,0,0,0-1.22-.64v3.16A2.37,2.37,0,0,0,147.8,275.06Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149,277a6.67,6.67,0,0,1-4,1.66v2.56h-2.29v-2.49a12.23,12.23,0,0,1-3.22-.6,8.13,8.13,0,0,1-2.47-1.23l1.26-2.79a8.27,8.27,0,0,0,2,1.07,9.5,9.5,0,0,0,2.4.55v-3.82a17.47,17.47,0,0,1-2.74-.87,4.87,4.87,0,0,1-1.88-1.41,3.76,3.76,0,0,1-.75-2.46,4.43,4.43,0,0,1,1.38-3.26,6.57,6.57,0,0,1,4-1.65v-2.54H145v2.49a10,10,0,0,1,4.65,1.4l-1.15,2.81a9.05,9.05,0,0,0-3.5-1.19v3.89a16.3,16.3,0,0,1,2.71.83,4.88,4.88,0,0,1,1.87,1.4,3.76,3.76,0,0,1,.75,2.44A4.3,4.3,0,0,1,149,277Zm-7.5-9.07a3.73,3.73,0,0,0,1.25.62v-3.25a2.49,2.49,0,0,0-1.28.65,1.5,1.5,0,0,0-.41,1A1.19,1.19,0,0,0,141.47,268Zm4.78,7.11a1.34,1.34,0,0,0,.41-1,1.2,1.2,0,0,0-.42-.94,3.79,3.79,0,0,0-1.23-.64v3.16A2.45,2.45,0,0,0,146.25,275.06Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.22,
    cy: 105.78,
    r: 20.02,
    transform: "translate(-1.8 207.2) rotate(-45)",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.1,
    cy: 105.78,
    r: 20.02,
    transform: "translate(86.61 320.99) rotate(-76.72)",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.1,
    cy: 105.78,
    r: 20.02,
    transform: "translate(86.61 320.99) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.1,
    cy: 105.78,
    r: 15.39,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,105.78a15.38,15.38,0,0,1,14.22-15.33c-.39,0-.77-.06-1.17-.06a15.39,15.39,0,1,0,0,30.78c.4,0,.78,0,1.17-.06A15.38,15.38,0,0,1,233.05,105.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.33,111.34a6.58,6.58,0,0,1-4,1.66v2.57h-2.29v-2.5a12.64,12.64,0,0,1-3.23-.59,8.25,8.25,0,0,1-2.47-1.24l1.26-2.79a8.2,8.2,0,0,0,2,1.08,8.9,8.9,0,0,0,2.4.54v-3.82a16.61,16.61,0,0,1-2.75-.87,4.74,4.74,0,0,1-1.87-1.4,3.75,3.75,0,0,1-.76-2.46,4.39,4.39,0,0,1,1.39-3.26,6.55,6.55,0,0,1,4-1.66V94.06h2.29v2.49A10.12,10.12,0,0,1,254,98l-1.14,2.81a9.28,9.28,0,0,0-3.5-1.19v3.89a17.57,17.57,0,0,1,2.71.84,4.75,4.75,0,0,1,1.86,1.39,3.77,3.77,0,0,1,.76,2.44A4.31,4.31,0,0,1,253.33,111.34Zm-7.5-9.07a3.52,3.52,0,0,0,1.26.62V99.64a2.53,2.53,0,0,0-1.28.65,1.48,1.48,0,0,0-.41,1A1.15,1.15,0,0,0,245.83,102.27Zm4.78,7.12a1.33,1.33,0,0,0,.41-1,1.17,1.17,0,0,0-.42-.93,3.55,3.55,0,0,0-1.22-.64V110A2.44,2.44,0,0,0,250.61,109.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,111.34a6.63,6.63,0,0,1-4,1.66v2.57h-2.29v-2.5a12.72,12.72,0,0,1-3.23-.59,8.25,8.25,0,0,1-2.47-1.24l1.26-2.79a8.2,8.2,0,0,0,2,1.08,9.07,9.07,0,0,0,2.4.54v-3.82a16.61,16.61,0,0,1-2.75-.87,4.81,4.81,0,0,1-1.87-1.4,3.8,3.8,0,0,1-.76-2.46,4.42,4.42,0,0,1,1.39-3.26,6.55,6.55,0,0,1,4-1.66V94.06h2.29v2.49a10.12,10.12,0,0,1,4.64,1.4l-1.14,2.81a9.28,9.28,0,0,0-3.5-1.19v3.89a17.23,17.23,0,0,1,2.71.84,4.75,4.75,0,0,1,1.86,1.39,3.71,3.71,0,0,1,.76,2.44A4.33,4.33,0,0,1,251.78,111.34Zm-7.51-9.07a3.52,3.52,0,0,0,1.26.62V99.64a2.53,2.53,0,0,0-1.28.65,1.48,1.48,0,0,0-.41,1A1.15,1.15,0,0,0,244.27,102.27Zm4.78,7.12a1.34,1.34,0,0,0,.42-1,1.18,1.18,0,0,0-.43-.93,3.55,3.55,0,0,0-1.22-.64V110A2.44,2.44,0,0,0,249.05,109.39Z",
    style: {
      fill: "#900045"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.67,251.17H272.11a2,2,0,0,0-2.05,2.05v23.55a2.05,2.05,0,0,0,2.05,2.06h0v4a1.43,1.43,0,0,0,2.43,1l5-5h16.13a2.05,2.05,0,0,0,2.05-2.06V253.22A2,2,0,0,0,295.67,251.17Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.48,262.68H277.93l-.47-1.74h-4.21v.78h3.61l2.61,9.64h8.64v-.78h-8l-.46-1.69h8.78Zm-11.08,5.43-1.26-4.65h11.25l-1.56,4.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.9,
    cy: 272.41,
    r: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.89,272.41a.78.78,0,1,1-.78-.78A.78.78,0,0,1,288.89,272.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 287.91,
    cy: 260.16,
    r: 4.59,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.91,
    cy: 260.16,
    r: 4.59,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.77,263.13,284,259.22a1.54,1.54,0,0,1,0-2.17h0a1.53,1.53,0,0,1,2.17,0l1.65,1.71,5-5.05a1.53,1.53,0,0,1,2.17,0h0a1.53,1.53,0,0,1,0,2.16Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Store--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.21,
    y: 159.65,
    width: 88.34,
    height: 71.79,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.21,
    y: 159.65,
    width: 88.34,
    height: 71.79,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.16,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.98,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.81,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.64,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.16,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.98,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.81,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.64,
    y: 151.64,
    width: 13.49,
    height: 9.56,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.06,167.81c0,2.33-3.11,4.22-7,4.22s-7-1.89-7-4.22V161.1h13.49Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.91,167.81c0,2.33-3.11,4.22-7,4.22s-6.95-1.89-6.95-4.22V161.1h13.5Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.76,167.81c0,2.33-3.11,4.22-6.95,4.22s-6.95-1.89-6.95-4.22V161.1h13.5Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.14,167.81c0,2.33-2.71,4.22-6.55,4.22s-7-1.89-7-4.22V161.1h13.5Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.06,161.1v-9.46H102.57v9.55h0v6.62c0,2.33,3.11,4.22,7,4.22s6.55-1.89,6.55-4.22V161.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.06,151.64H102.57v16.17c0,2.33,3.11,4.22,7,4.22s6.55-1.89,6.55-4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,161.1v-9.46H129.48v9.55h0v6.62c0,2.33,3.11,4.22,6.95,4.22s6.55-1.89,6.55-4.22V161.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,151.64H129.48v16.17c0,2.33,3.11,4.22,6.95,4.22s6.55-1.89,6.55-4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,161.1v-9.46H156.31v9.55h0v6.62c0,2.33,3.11,4.22,7,4.22s6.55-1.89,6.55-4.22V161.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,151.64H156.31v16.17c0,2.33,3.11,4.22,7,4.22s6.55-1.89,6.55-4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.71,
    y: 182.11,
    width: 40.29,
    height: 22.86,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.51 204.95 149.22 204.95 154.69 182.34 161.99 182.34 156.51 204.95",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.05 204.95 158.43 204.95 163.91 182.34 165.52 182.34 160.05 204.95",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.58 204.95 136.76 204.95 142.24 182.34 143.06 182.34 137.58 204.95",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,205.77H129.91V181.31H171.8Zm-40.29-1.6H170.2V182.91H131.51Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.67,
    y: 173.75,
    width: 24.22,
    height: 57.49,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.7,
    y: 174.79,
    width: 22.16,
    height: 56.44,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.38,
    y: 182.24,
    width: 8.88,
    height: 20.67,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.42,
    y: 182.24,
    width: 8.88,
    height: 20.67,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.38,
    y: 209.16,
    width: 18.92,
    height: 20.67,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,181.17H99.38a4.88,4.88,0,0,1,4.88-4.88h9.17a4.88,4.88,0,0,1,4.88,4.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.38,
    y: 203.84,
    width: 1.62,
    height: 4.21,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.38,
    y: 203.84,
    width: 1.62,
    height: 4.21,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 203.84,
    width: 0.32,
    height: 4.21,
    transform: "translate(202.31 411.89) rotate(180)",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.46,205.49a.68.68,0,1,1-.68-.68A.68.68,0,0,1,100.46,205.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.98,
    y: 206.67,
    width: 0.35,
    height: 0.85,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.18,
    cy: 205.49,
    r: 0.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.18,
    cy: 205.49,
    r: 0.95,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.01 248.92 318.38 248.92 325.19 257.86 360.81 257.86 354.01 248.92",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.01 248.92 318.38 248.92 325.19 257.86 360.81 257.86 354.01 248.92",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.26 248.92 389.14 248.92 382.7 257.86 360.81 257.86 367.26 248.92",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.26 248.92 389.14 248.92 382.7 257.86 360.81 257.86 367.26 248.92",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 257.86,
    width: 35.63,
    height: 35.63,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 257.86,
    width: 35.63,
    height: 35.63,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.77,
    y: 257.86,
    width: 6.45,
    height: 8.02,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.77,
    y: 287.05,
    width: 6.45,
    height: 6.44,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.81,
    y: 257.86,
    width: 21.88,
    height: 35.63,
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.81,
    y: 257.86,
    width: 21.88,
    height: 35.63,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.03,
    y: 283.01,
    width: 6.45,
    height: 9.83,
    transform: "translate(656.18 -80.33) rotate(90)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.32,390.58c8.24.42,12.36.68,20.59,1.33q-2-44.46-5.17-88.84c-.28-3.76-3.92-7-8.12-7.25l-8-.4c-31.19-1.16-62.24-.82-93.4,1q10.45,46.88,19.47,94C224.64,389.48,249.4,389.51,274.32,390.58Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,390.58c8.24.42,12.36.68,20.59,1.33q-2-44.46-5.17-88.84c-.28-3.76-3.92-7-8.12-7.25l-8-.4c-31.19-1.16-62.24-.82-93.4,1q10.45,46.88,19.47,94C224.64,389.48,249.4,389.51,274.32,390.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.91,390.1c-8.24.3-12.36.51-20.6,1q-8.34-43.72-17.74-87.21c-.81-3.68,1.94-6.94,6.15-7.24,3.18-.22,4.78-.33,8-.52,4.21-.26,8.2,2.57,8.9,6.27Q201.8,346.18,208.91,390.1Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,406.53l-3.9-44.62a4.26,4.26,0,0,0-3.7-3.84l-1.61-.21a5.71,5.71,0,0,1-5-5.16l-.71-8.13a5.71,5.71,0,0,1,5.69-6.21h-36a5.71,5.71,0,0,0-5.68,6.21l.71,8.13a5.71,5.71,0,0,0,5,5.16l1.61.21a4.26,4.26,0,0,1,3.7,3.84l3.9,44.62a6.29,6.29,0,0,0,6.27,5.74h36A6.3,6.3,0,0,1,220.4,406.53Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.4,406.53l-3.9-44.62a4.26,4.26,0,0,0-3.7-3.84l-1.61-.21a5.71,5.71,0,0,1-5-5.16l-.71-8.13a5.71,5.71,0,0,1,5.69-6.21h-36a5.71,5.71,0,0,0-5.68,6.21l.71,8.13a5.71,5.71,0,0,0,5,5.16l1.61.21a4.26,4.26,0,0,1,3.7,3.84l3.9,44.62a6.29,6.29,0,0,0,6.27,5.74h36A6.3,6.3,0,0,1,220.4,406.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.48,350.75A13.57,13.57,0,0,1,333,338.36H301.65a13.58,13.58,0,0,0-13.52,12.39L285,386.11h31.34Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.48,350.75A13.57,13.57,0,0,1,333,338.36H301.65a13.58,13.58,0,0,0-13.52,12.39L285,386.11h31.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.49,384.46A353.37,353.37,0,0,1,247.13,386a5.66,5.66,0,0,1-5.38-6c.63-5.73.94-8.59,1.57-14.32a5.55,5.55,0,0,1,6-4.88,259.75,259.75,0,0,0,59.7-1.44,5.56,5.56,0,0,1,6.27,4.58l2.25,14.23A5.65,5.65,0,0,1,312.49,384.46Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93,360.8c-5-.45-7.43-.73-12.36-1.41a5.56,5.56,0,0,0-6.28,4.58L228,378.2a5.65,5.65,0,0,0,5.08,6.26c5.41.74,8.11,1.05,13.54,1.54C247.57,375.92,248,370.88,248.93,360.8Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.49,384.46A353.37,353.37,0,0,1,247.13,386a5.66,5.66,0,0,1-5.38-6c.63-5.73.94-8.59,1.57-14.32a5.55,5.55,0,0,1,6-4.88,259.75,259.75,0,0,0,59.7-1.44,5.56,5.56,0,0,1,6.27,4.58l2.25,14.23A5.65,5.65,0,0,1,312.49,384.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.91,338.36H333a13.57,13.57,0,0,0-13.51,12.39l-3.1,35.36H241.73l-3.09-35.36a13.57,13.57,0,0,0-13.51-12.39H211.21a5.71,5.71,0,0,0-5.69,6.21l.71,8.13a5.71,5.71,0,0,0,5,5.16l1.61.21a4.26,4.26,0,0,1,3.7,3.84l3.9,44.62a6.3,6.3,0,0,0,6.27,5.74H331.44a6.3,6.3,0,0,0,6.28-5.74l3.9-44.62a4.24,4.24,0,0,1,3.7-3.84l1.6-.21a5.7,5.7,0,0,0,5-5.16l.71-8.13A5.7,5.7,0,0,0,346.91,338.36Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.91,338.36H333a13.57,13.57,0,0,0-13.51,12.39l-3.1,35.36H241.73l-3.09-35.36a13.57,13.57,0,0,0-13.51-12.39H211.21a5.71,5.71,0,0,0-5.69,6.21l.71,8.13a5.71,5.71,0,0,0,5,5.16l1.61.21a4.26,4.26,0,0,1,3.7,3.84l3.9,44.62a6.3,6.3,0,0,0,6.27,5.74H331.44a6.3,6.3,0,0,0,6.28-5.74l3.9-44.62a4.24,4.24,0,0,1,3.7-3.84l1.6-.21a5.7,5.7,0,0,0,5-5.16l.71-8.13A5.7,5.7,0,0,0,346.91,338.36Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.6 393.88 304.95 409.43 310.17 407.63 309.56 392.92 301.6 393.88",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.65,328.6a53.52,53.52,0,0,0,14.8-1.93L272.37,337s30.79-5.52,34.71,4c3.35,8.09,3.49,58,3.49,58L302,400s-9.39-36.33-9.35-48.36a1.13,1.13,0,0,0-1.82-.91c-4.73,3.68-17.32,11.64-36.38,10.41-2.95-.19-6.4-.83-5.52-10.46A207.2,207.2,0,0,1,252.65,328.6Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.71,356c8.45-3.75,20.17-14,25.59-17.8a11.69,11.69,0,0,1,4.21-1.95c-4.7-1-10.72-1-15.9-.59l-12.29,5.43-19.73,8.8-2.44,7c.85,3.75,3.21,4.14,5.33,4.28a56.53,56.53,0,0,0,22.17-2.88C275.67,358.34,261.56,359.61,269.71,356Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.58 365.39 339.14 376.06 343.24 372.83 335.1 360.59 328.58 365.39",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.48,371.37,337.72,375a.57.57,0,0,0-.16.68l2.41,5.2a.93.93,0,0,0,1.22.46,1,1,0,0,0,.17-.1c1.95-1.54,3.62-3,6.07-4.87,2.9-2.21,2.43-1.3,5.87-3.86,2.08-1.54.67-4.16-.29-3.61-4.37,2.54-6.41,2.2-9,1.95A2.2,2.2,0,0,0,342.48,371.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.84,336.13l5.26,1.26s9.84-7.65,5.25-5.12c-3.35,1.86-5-2-5.69-4.19-2.09.29-3.92.42-5.3.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1,328c-13.05,2.16-18.81.13-18.81.13s-9.3,33.41,11.21,33.27c9.09-.06,12.86-3.62,18.77-7.09,13.44-7.89,24.54-19.58,29.74-18.82,7.47,1.08,3.24,10,33.71,34.77l6.32-5.56s-26.33-47.29-40.16-47.19c-13.32.09-34.75,16.83-37.57,16.85S258.1,328,258.1,328Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,337.39h0a7.13,7.13,0,0,1,3.92,3.58,21.09,21.09,0,0,1,1.06,4.44c.86,1.24,1.88,2.63,3.08,4.15C310.43,339.54,303.17,337.39,303.17,337.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,406.23l-6,.36a.55.55,0,0,0-.52.46l-.91,5.67a.91.91,0,0,0,.76,1.06.61.61,0,0,0,.19,0c2.48-.19,4.67-.45,7.76-.63,3.64-.22,2.74.27,7,.08,2.59-.12,2.88-3.08,1.78-3.16-5-.33-6.54-1.76-8.58-3.44A2.23,2.23,0,0,0,310.09,406.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.56,283.66c1.69-.65,4.49.47,6.92,4.81s12.77,22.24,9.83,24.54-8.57-4.22-10.64-8.9S253.6,284.81,256.56,283.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.1,291.92l.36,2.87-.19,6.21c.56,1.25,1.05,2.32,1.4,3.11a24.23,24.23,0,0,0,3.43,5.4c.44-8.75-2.86-17.59-2.86-17.59Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.65,328.77s18.07,2.15,29.6-1.64c0,0-3.51-4.42-4-13.27-.45-8.68,3.24-19.1-5.45-29.66a1.65,1.65,0,0,0-1.41-.6c-4.57.32-25.85,2-26.16,5.77C230.87,294.15,240.17,304.35,238.65,328.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,273.62s2.37,6.91.53,9.87c0,0,6.65.34,8.27-1.83,0,0-.94-.51-1.24-3.15S245.15,273.14,240.42,273.62Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,278.51c-.27-2.44-2.47-5-6.56-4.94l-.28.25-.29.53s2.51,6.74,7.55,6A7.6,7.6,0,0,1,248,278.51Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.92,264.45c.79,6.35,1,9.06,4.41,12.13,5.16,4.63,12.79,2.27,13.92-4.2,1-5.82-.45-15.23-6.85-17.38a8.74,8.74,0,0,0-11.48,9.45Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,268.19a14,14,0,0,0,2.06,3.2,2.22,2.22,0,0,1-1.82.47Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.37,264.88l-.12-.05a.26.26,0,0,1,0-.36h0a3,3,0,0,1,2.48-1.18.26.26,0,0,1-.05.51,2.46,2.46,0,0,0-2,1A.27.27,0,0,1,246.37,264.88Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,263.87l-.12-.05a2.48,2.48,0,0,0-2.21-.45.25.25,0,0,1-.33-.14h0a.24.24,0,0,1,.16-.32,3,3,0,0,1,2.69.51.25.25,0,0,1,.06.35.26.26,0,0,1-.25.11Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25,267.56c0,.52.34.92.68.9s.59-.45.55-1-.33-.92-.67-.9S248.22,267,248.25,267.56Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,267.19c0,.52.33.92.67.9s.58-.45.55-1-.33-.92-.67-.9S254.09,266.67,254.13,267.19Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.54,266.25l1.22-.43S255.18,266.83,254.54,266.25Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,266.62l1.23-.44S249.3,267.2,248.66,266.62Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.89,272.77a3.68,3.68,0,0,1-.37-.51.13.13,0,0,1,0-.17h0a.14.14,0,0,1,.17,0,3.35,3.35,0,0,0,2.57,1.62.13.13,0,0,1,0,.25A3.46,3.46,0,0,1,248.89,272.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.85,306c-1-4.52-4.43-12.31-4.43-12.31l-2.49-.69-1.22,1.68c2.17,5.4,6,14,6.1,28.2,4.8-.15,10.11-6.92,10.11-6.92l-2.72-6C243.17,311.46,241.82,310.56,240.85,306Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,269.5s4.12-1.88,1.72-5.41c0,0,4.22.58,4.57-3.54,0,0,3.75,1.89,5.86-1.05,0,0,4,2.27,4.92-.57s-2.2-3.59-2.2-3.59.48-2.8-1.14-3.54a3.45,3.45,0,0,0-3.24.49s-.31-3.34-3-3.21a5.5,5.5,0,0,0-4.14,2.54,5.41,5.41,0,0,0-5-.38c-2.67,1.21-3.11,4.85-3.11,4.85s-3,.61-3.49,2.93.47,3.11.47,3.11-1.62,2.23-1.1,4.29,1.6,2,1.6,2a6.68,6.68,0,0,0,1.12,4.58c1.49,1.79,2.62,1,2.62,1s.49,4,3.23,3.59S239.74,269.5,239.74,269.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,269.59a4.67,4.67,0,0,0,2.43,2.62c1.5.68,2.49-.6,2.28-2.14-.18-1.38-1.19-3.41-2.79-3.44a2.13,2.13,0,0,0-2.09,2.15A2.1,2.1,0,0,0,236.72,269.59Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,285.72l1.62-4.74a11.52,11.52,0,0,0,5.37.68c2-.23,1.93-1.13,1.93-1.13l4,3.46-1.71,2.19-3.07-1.41-2.32,2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,285.72l1.62-4.74a11.52,11.52,0,0,0,5.37.68c2-.23,1.93-1.13,1.93-1.13l4,3.46-1.71,2.19-3.07-1.41-2.32,2.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,304.43H258a1.14,1.14,0,0,1-1.14-1.45L259,292.86a1.88,1.88,0,0,1,1.75-1.45h3.88a1.14,1.14,0,0,1,1.13,1.45L263.61,303A1.88,1.88,0,0,1,261.86,304.43Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,304.43H258a1.14,1.14,0,0,1-1.14-1.45L259,292.86a1.88,1.88,0,0,1,1.75-1.45h3.88a1.14,1.14,0,0,1,1.13,1.45L263.61,303A1.88,1.88,0,0,1,261.86,304.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,304.43h-3.87a1.14,1.14,0,0,1-1.14-1.45l2.15-10.12a1.88,1.88,0,0,1,1.75-1.45h3.88a1.14,1.14,0,0,1,1.13,1.45L264.18,303A1.88,1.88,0,0,1,262.43,304.43Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,304.43h-3.87a1.14,1.14,0,0,1-1.14-1.45l2.15-10.12a1.88,1.88,0,0,1,1.75-1.45h3.88a1.14,1.14,0,0,1,1.13,1.45L264.18,303A1.88,1.88,0,0,1,262.43,304.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89,294.41h.38a1.27,1.27,0,0,0,1.17-1l.08-.38a.76.76,0,0,0-.76-1h-.38a1.27,1.27,0,0,0-1.17,1l-.08.38A.76.76,0,0,0,260.89,294.41Z",
    style: {
      fill: "#900045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.82,292.67a.5.5,0,0,1-.48.4.31.31,0,0,1-.32-.4.53.53,0,0,1,.49-.4A.31.31,0,0,1,261.82,292.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.58,293.83a.53.53,0,0,1-.49.4.32.32,0,0,1-.32-.4.53.53,0,0,1,.49-.4A.32.32,0,0,1,261.58,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,308.63l-5.43-4.19s-2.12-4.62-3.59-5.2a2,2,0,0,0-2.17.72c-.86,1.06-.95,4.41-.08,5.47s3.52,1.76,3.52,1.76l5.08,5.29Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,313.28c-2.53,2.38-5.07-.54-7.66-3.48a6.27,6.27,0,0,0,3.34-4S277.33,310.16,274,313.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,309.8l.75.85a7.49,7.49,0,0,0,3.51-4.26c-.54-.37-.92-.58-.92-.58A6.27,6.27,0,0,1,266.35,309.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,308.63l5.43-4.19s2.12-4.62,3.59-5.2a2,2,0,0,1,2.17.72c.86,1.06.95,4.41.08,5.47s-3.52,1.76-3.52,1.76l-5.08,5.29Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,303.52c-.87-3.45-1.84-12.09,1.5-14.84s5.26,4.77,6.58,10.56,2,13.55,4.95,12.35a51.94,51.94,0,0,0,7.61-4.66l3.39,4.78s-10.35,11.93-14.9,8.41S230.87,307.89,229.76,303.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.14,307.83l3.48,5.15c.73-.76,1.17-1.27,1.17-1.27l-3.39-4.78S249.9,307.3,249.14,307.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdering);
export default __webpack_public_path__ + "static/media/ordering.2fc1c4dd3d733ac87f848289bcd4f3ca.svg";
export { ForwardRef as ReactComponent };